/**
 * Public race type presets with realistic duration and zone distribution.
 * Based on typical race demands: Crit (short, high Z4/Z5), TT (steady Z4), Gran Fondo (long Z2/Z3), etc.
 * Users can duplicate a public type to "Your race types" and then edit it in Manage.
 */
export const PUBLIC_RACE_TYPES = [
  {
    id: 'public:crit',
    name: 'Criterium',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 45,
      zoneMix: { z1: 5, z2: 10, z3: 15, z4: 45, z5: 25 },
    },
  },
  {
    id: 'public:tt',
    name: 'Time Trial',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 20,
      zoneMix: { z1: 5, z2: 5, z3: 10, z4: 75, z5: 5 },
    },
  },
  {
    id: 'public:xco',
    name: 'XCO',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 90,
      zoneMix: { z1: 10, z2: 25, z3: 25, z4: 30, z5: 10 },
    },
  },
  {
    id: 'public:gravel',
    name: 'Gravel',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 180,
      zoneMix: { z1: 15, z2: 50, z3: 25, z4: 8, z5: 2 },
    },
  },
  {
    id: 'public:granfondo',
    name: 'Gran Fondo',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 300,
      zoneMix: { z1: 20, z2: 55, z3: 20, z4: 4, z5: 1 },
    },
  },
  {
    id: 'public:downhill',
    name: 'Downhill',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 5,
      zoneMix: { z1: 10, z2: 20, z3: 30, z4: 25, z5: 15 },
    },
  },
  {
    id: 'public:enduro',
    name: 'Enduro',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 180,
      zoneMix: { z1: 25, z2: 35, z3: 25, z4: 12, z5: 3 },
    },
  },
  {
    id: 'public:road_race',
    name: 'Road Race',
    defaults: {
      effortMode: 'percent',
      durationMinutes: 180,
      zoneMix: { z1: 15, z2: 40, z3: 25, z4: 15, z5: 5 },
    },
  },
  {
    id: 'public:other',
    name: 'Other',
    defaults: null,
  },
];

export function buildRaceTypeOptions(userRaceTypes) {
  const userList = Array.isArray(userRaceTypes)
    ? userRaceTypes
        .filter((t) => t && typeof t.id === 'string' && typeof t.name === 'string')
        .map((t) => ({
          id: t.id,
          name: t.name,
          defaults: t.defaults || null,
          isPublic: false,
        }))
    : [];

  const publicList = PUBLIC_RACE_TYPES.map((t) => ({
    id: t.id,
    name: t.name,
    defaults: t.defaults ? { ...t.defaults } : null,
    isPublic: true,
  }));

  userList.sort((a, b) => a.name.localeCompare(b.name));
  return { publicList, userList };
}

/** Event priority for competitions: A = key race, B = important, C = tune-up */
export const EVENT_PRIORITY_OPTIONS = [
  { value: 'A', label: 'A race (key goal)' },
  { value: 'B', label: 'B race (important)' },
  { value: 'C', label: 'C race (tune-up)' },
];
